import { Pipe, PipeTransform } from '@angular/core';
import { DocumentSubType, DocumentSubTypeAR } from 'src/app/core/interfaces/invoice.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'documentSubTypeTranslator',
    pure: false
})
export class DocumentSubTypeTranslatorPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(value: string): string {
        if (!value) {
            return '';
        }

        const currentLang = this.localizationService.getCachedLanguage();
        if (currentLang === 'ar') {
            return DocumentSubTypeAR[value as keyof typeof DocumentSubTypeAR] || value;
        } else {
            return DocumentSubType[value as keyof typeof DocumentSubType] || value;
        }
    }
}
